import React, { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { toast } from "react-toastify";
import useApi from "../../../hook/useApi";

const TopEsimPackages = () => {
  const { AsyncGetApiCall } = useApi();
  const [topPackages, setTopPackages] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);

  useEffect(() => {
    const fetchEsimOrders = async () => {
      const result = await AsyncGetApiCall("/analytics/top-esim-packages");

      if (result?.success) {
        setTopPackages(result?.data?.packages || []);
        setTotalOrders(result?.data?.totalOrders || 0);
      } else {
        toast.error(result?.errors?.[0] || "Failed to fetch top eSIM packages");
      }
    };

    fetchEsimOrders();
  }, []);

  const series = topPackages.map((item) => item.count);

  const chartOptions = {
    chart: {
      type: "donut",
      toolbar: { show: false },
    },
    labels: topPackages.map((item) =>
      item.packageCode.length > 16 ? `${item.packageCode.slice(0, 16)}...` : item.packageCode
    ),
    legend: {
      show: true,
      position: "bottom",
      fontSize: "11px",
      formatter: (seriesName, opts) => {
        const fullName = topPackages[opts.seriesIndex]?.packageCode || seriesName;
        return fullName.length > 20 ? `${fullName.slice(0, 20)}...` : fullName;
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "20%",
        },
      },
    },
    dataLabels: {
      enabled: true,
      formatter: (val) => `${Math.round(val)}%`,
      style: {
        fontSize: "10px",
      },
    },
    tooltip: {
      x: {
        formatter: (_, opts) => topPackages[opts.dataPointIndex]?.packageCode || "Package",
      },
      y: {
        formatter: (val) => `${val} Orders`,
      },
    },
  };

  return (
    <div className="col-xxl-3 col-xl-6">
      <div className="card h-100 radius-8 border">
        <div className="card-body p-24">
          <h6 className="mb-12 fw-semibold text-lg mb-16">Top eSIM Packages</h6>
          <div className="d-flex align-items-center gap-2 mb-20">
            <h6 className="fw-semibold mb-0">{totalOrders} Orders</h6>
          </div>
          <ReactApexChart
            options={chartOptions}
            series={series}
            type="donut"
            height={350}
          />
        </div>
      </div>
    </div>
  );
};

export default TopEsimPackages;
